app.pagecontent = (function () {
    var myPageContent = {
        Init: function () {
            this.BindContentEditor(document);
            $(document).on('component-bind-edit-mode-complete', function (e, component) {
                app.pagecontent.BindContentEditor(component.el);
            });
        },
        BindContentEditor: function (el) {
            $('.pagecontent-placeholder', $(el)).on('click', function () {
                $.ajax({
                    url: '/Admin/PageContent/EditForm',
                    data: {
                        mnemonic: $(this).data('pagecontentmnemonic'),
                        isTooltip: $(this).data('istooltip')
                    },
                    context: this,
                    error: app.page.handleAjaxError
                }).done(function (data) {
                    $('#pageContentModal #pageContentForm').html(data);
                    app.util.openModal($('#pageContentModal'));
                    app.input.initTextEditor($('#pageContentModal'));
                });
            });
        }
    };
    return myPageContent;
}());

$(function () {
    app.pagecontent.Init();
});